import { render } from "./InvoiceDetails.vue?vue&type=template&id=0116d8e6&scoped=true"
import script from "./InvoiceDetails.vue?vue&type=script&lang=js"
export * from "./InvoiceDetails.vue?vue&type=script&lang=js"

import "./InvoiceDetails.vue?vue&type=style&index=0&id=0116d8e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0116d8e6"]])

export default __exports__